import { useSearchParams } from "react-router-dom"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { SubscriptionsByMember } from "../components/SubscriptionTabsByMember"
import { SubscriptionsByEvent } from "../components/SubscriptionTabsByEvent"
import { useEffect } from "react"
import { useAuth } from "@/modules/Auth/context/AuthContext"
import { PageHeader } from "@/components/Molecules/PageHeader/PageHeader"

export function EventsSubscriptionsPage() {
  const [searchParams, setSearchParams] = useSearchParams()
  const { user } = useAuth()

  const activeTab = searchParams.get("activeTab") || "by-event"

  const handleTabChange = (value: string) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev)
      next.set("activeTab", value)
      return next
    })
  }

  useEffect(() => {
    if (!user.pesAdmin && activeTab !== "by-event") {
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev)
        next.set("activeTab", "by-event")
        return next
      })
    }
  }, [user.pesAdmin, activeTab])

  return (
    <div className="w-full">
      <PageHeader
        title="Gestão de inscrições"
        icon="login"
      />
      <Tabs
        className="px-6"
        value={activeTab}
        onValueChange={handleTabChange}
      >
        <TabsList className="bg-white/10">
          <TabsTrigger value="by-event">Por Evento</TabsTrigger>
          <TabsTrigger value="by-member">Por Colaborador</TabsTrigger>
        </TabsList>
        <TabsContent value="by-event">
          <SubscriptionsByEvent />
        </TabsContent>
        <TabsContent value="by-member">
          <SubscriptionsByMember />
        </TabsContent>
      </Tabs>
    </div>
  )
}
